module.exports = __webpack_public_path__ + "img/Img_Visite-nos.00d7c8f5.jpg";